<div class="modal is-right" [ngClass]="{ 'is-active': isCartOpen }">
  <div class="modal-card" *ngIf="favoriteIncentives">
    <header class="modal-card-head">
      <h3 class="title is-4 has-text-weight-bold">
        Comparison preview
        <a routerLink="/comparator" class="pl-2"
          ><i class="fa-regular fa-circle-right"></i
        ></a>
      </h3>
    </header>
    <section class="modal-card-body pt-0">
      <ng-container *ngIf="favoriteIncentives.length >= 1">
        <div
          class="card card--message has-background-success-light mb-8 is-shadowless is-bordered has-text-dark"
        >
          <div class="card-content" *ngIf="lastAddedIncentives?.length">
            <div class="content">
              <div class="media">
                <div class="media-left">
                  <i class="fa-solid fa-list-check mt-1"></i>
                </div>
                <div class="media-content">
                  <p *ngIf="lastAddedIncentives.length === 1">
                    The incentive has been added with success.
                  </p>
                  <p *ngIf="lastAddedIncentives.length > 1">
                    The incentives has been added with success.
                  </p>
                  <p>
                    If you wish, you can remove your previous selection by
                    clicking on the button below. Otherwise you can continue to
                    add incentives to your comparison.
                  </p>
                  <p class="has-text-right">
                    <a
                      class="icon-text no-deco has-text-link-dark is-inside-cart"
                      (click)="removeOldFavorites()"
                    >
                      <span class="icon is-inside-cart">
                        <i class="fa-solid fa-chevron-right is-inside-cart"></i>
                      </span>
                      <span
                        *ngIf="lastAddedIncentives.length === 1"
                        class="is-inside-cart"
                        >Remove all but the last incentive
                      </span>
                      <span
                        *ngIf="lastAddedIncentives.length > 1"
                        class="is-inside-cart"
                        >Remove all but the last incentives
                      </span>
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="card is-bordered is-shadowless mb-2"
          *ngFor="let favoriteIncentive of favoriteIncentives"
          [routerLink]="['incentives', favoriteIncentive.id]"
          @fadeInFlash
        >
          <div class="card-content content is-small p-2">
            <div
              class="is-flex is-align-items-center is-justify-content-space-between"
            >
              <div
                class="is-flex is-align-items-center is-justify-content-flex-start"
              >
                <img
                  class="flag is-small mr-2"
                  src="./assets/images/flags/{{ favoriteIncentive.image }}.png"
                  alt="{{ favoriteIncentive.image }} flag"
                  [routerLink]="['incentives', favoriteIncentive.id]"
                />
                <span>
                  {{ favoriteIncentive.label }}
                </span>
              </div>
              <i
                class="fa-solid fa-trash p-2"
                title="Remove from comparison"
                (click)="remove(favoriteIncentive.id)"
              ></i>
            </div>
          </div></div
      ></ng-container>

      <ng-container *ngIf="favoriteIncentives.length === 0">
        <div class="content is-small">
          <p>you haven't selected any incentive yet.</p>
          <p class="has-text-weight-bold">
            How to add incentives for comparison ?
          </p>
          <ol>
            <li>
              Go to
              <a routerLink="/incentives">find incentives</a> page using the
              navbar.
            </li>
            <li>Use the filters to find incentives</li>
            <li>
              On the filtered list of incentives, click on the incentives you
              are interested in.
              <br />
              <img
                src="assets/images/selecting-incentives.gif"
                width="100%"
                class="is-bordered mt-2"
              />
            </li>
            <li>
              You will see your selection here and you can access the comparison
              interface using the button below.
            </li>
          </ol>
        </div>
      </ng-container>
    </section>

    <footer
      class="modal-card-foot has-background-white-bis is-flex-direction-column"
    >
      <span [ngPlural]="favoriteIncentives.length">
        <ng-template ngPluralCase="=0">
          <a
            class="button is-link is-fullwidth"
            routerLink="/comparator"
            [attr.disabled]="favoriteIncentives.length === 0 ? true : null"
            >Compare 0 incentive
          </a>
        </ng-template>
        <ng-template ngPluralCase="=1">
          <a
            class="button is-link is-fullwidth"
            routerLink="/comparator"
            [attr.disabled]="favoriteIncentives.length === 0 ? true : null"
            >Explore the incentive
          </a>
        </ng-template>
        <ng-template ngPluralCase="other">
          <a
            class="button is-link is-fullwidth"
            routerLink="/comparator"
            [attr.disabled]="favoriteIncentives.length === 0 ? true : null"
            >Compare {{ favoriteIncentives.length }} incentives
          </a>
        </ng-template>
      </span>
      <a
        (click)="resetFavorites()"
        class="is-inside-cart mt-2"
        *ngIf="favoriteIncentives.length"
        >Reset comparison</a
      >
    </footer>
  </div>
</div>
